export type InitVerificationResult = {
  verificationId: string
  url: string
  verificationType: VerificationType
}

export enum VerificationStatus {
  CREATED = 'created',
  STARTED = 'started',
  SUBMITTED = 'submitted',
  APPROVED = 'approved',
  RESUBMISSION_REQUESTED = 'resubmission_requested',
  REVIEW = 'review',
  DECLINED = 'declined',
  EXPIRED = 'expired',
  ABANDONED = 'abandoned',
}

export enum VerificationType {
  VERIFF = 0,
  KYCAID = 1,
}

export interface Verification {
  id: string
  sessionId: string
  type: VerificationType
  status: VerificationStatus
  updatedAt: Date
}
